export default "__VITE_ASSET__B0b3HrV4__"